import React, { Component } from 'react';

// import ContactForm from '../components/ContactForm';
import HeroSection from '../components/HeroSection';
// import PageSection from '../components/PageSection';

class Home extends Component {

  render() {
    return (
      <main>
        <HeroSection
            imageSrc="https://res.cloudinary.com/dpoz8quj5/image/upload/v1510280522/olympic_1600w_ygtkqw.jpg"
            imagePosY="bottom"
            h1="Peter Liu" h2="Web Developer + Photographer">
        </HeroSection>
        <section className="flex-section">
          <h1>About Me</h1>
          <div className="about-blurb" style={{ width: '90vw', margin: '0 auto' }}>
            <p>I'm a <a href="/webdev">web developer</a>, <a href="/photo">photographer</a>, and <a href="http://wkdu.org/program/deep-end" target="_blank" rel="noopener noreferrer">radio DJ</a>.</p>
            <p>I specialize in building data-driven websites from the ground up, backed by a quality user experience, and carefully created to maximize user engagement.</p>
            <p>Instilled with a DIY ethos while growing up in Philadelphia, I constantly strive to learn more about the world around me.</p>
            <p style={{ fontSize: '1.2em' }}>Got an idea for a project? Let's talk!</p>
          </div>
        </section>
      </main>
    );

    //
    // return (
    //   <main>
    //     <HeroSection
    //         imageSrc="http://res.cloudinary.com/dpoz8quj5/image/upload/v1510280522/olympic_1600w_ygtkqw.jpg"
    //         imagePosY="bottom"
    //         h1="Peter Liu" h2="Web Developer + Photographer">
    //     </HeroSection>
    //     <PageSection>
    //       <h1>About Me</h1>
    //       <div className="about-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
    //         <div className="about-flex" style={{ display: 'flex' }}>
    //           <div className="about-profile">
    //             <img src="" alt="Peter Liu"/>
    //             <div className="links">
    //               <h2></h2>
    //             </div>
    //           </div>
    //           <div className="about-blurb">
    //             <p>I'm a <a href="/webdev">web developer</a>, <a href="/photo">photographer</a>, and <a href="http://wkdu.org/program/deep-end" target="_blank" rel="noopener noreferrer">radio DJ</a>.</p>
    //             <p>I specialize in building data-driven websites from the ground up, backed by a quality user experience, and carefully created to maximize information.</p>
    //             <p>Raised with a DIY ethos in the streets and suburbs of Philadelphia, I constantly strive to learn more about the world around me.</p>
    //             <p style={{ fontSize: '1.25em' }}>Got an idea for a project? Let's talk!</p>
    //           </div>
    //         </div>
    //         <div className="about-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr' }}>
    //           <div className="skills" style={{ gridColumn: '1 / 3' , background: '#aaa'}}>What I do</div>
    //           <div className="cta" style={{ gridColumn: '3 / 6' , background: '#ddd'}}>Webdev</div>
    //           <div className="cta" style={{ gridColumn: '1 / 2' , background: '#aaa'}}>Photos</div>
    //           <div className="tools" style={{ gridColumn: '2 / 6' , background: '#ddd'}}>What I use</div>
    //         </div>
    //       </div>
    //     </PageSection>
    //   </main>
    // );
  }

}

export default Home;

// hero section
//      hero image with about info overlay
//      major relevant skills (use IconWrap)
// featured projects section
//      get { featured: true } projects from projects.json
// contact section
//      form for contact
// footer section
//      dev/photo-related social media - codepen, github, instagram, linkedin


// WEBPACK FOOTER //
// ./src/views/Home.js